import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { z } from 'zod';

import { HelpCentreRegulationsPage } from '@/features/help-centre/HelpCentreRegulationsPage';
import type { HelpFrameworkKey } from '@/features/help-centre/content';
import i18n from '@/lib/i18n';

const searchSchema = z.object({
  q: z.string().optional().default(''),
  framework: z.enum(['all', 'nis2', 'dora', 'iso27001', 'ghg-protocol']).optional().default('all'),
});

export const Route = createFileRoute('/_authenticated/help-centre/regulations')({
  validateSearch: searchSchema,
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.helpCentreRegulations'),
  }),
  component: HelpCentreRegulationsRoute,
});

function HelpCentreRegulationsRoute() {
  const navigate = useNavigate({ from: Route.fullPath });
  const search = Route.useSearch();

  const updateSearch = (updates: Partial<{ q: string; framework: HelpFrameworkKey | 'all' }>) => {
    void navigate({
      search: (prev) => ({
        ...prev,
        ...updates,
      }),
      replace: true,
    });
  };

  return (
    <HelpCentreRegulationsPage
      query={search.q}
      framework={search.framework}
      onQueryChange={(q) => updateSearch({ q })}
      onFrameworkChange={(framework) => updateSearch({ framework })}
    />
  );
}
